/**
 * Movepro CRM API interface
 *
 * @package Movepro CRM
 * @module Customer
 */

const ROUTE = '/customers';

function index() {
    return window.tenantAxios.get(ROUTE);
}

function create(customer) {
    return window.tenantAxios.post(ROUTE, customer);
}

function retrieve(id) {
    return window.tenantAxios.get(`${ROUTE}/${id}`);
}

function retrieveByEmail(email) {
    return window.tenantAxios.get(`${ROUTE}/by-email`, {
        params: { email },
    });
}

function update(id, customer) {
    return window.tenantAxios.put(`${ROUTE}/${id}`, customer);
}

function destroy(id) {
    return window.tenantAxios.delete(`${ROUTE}/${id}`);
}

// Helper API Services

export default {
    index,
    create,
    retrieve,
    retrieveByEmail,
    update,
    destroy,
};
